import { injectable, inject } from 'inversify';
import type { ITenantRepository } from '@/domain/repositories/ITenantRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class DeleteTenantAction {
  constructor(
    @inject(TYPES.ITenantRepository) private tenantRepository: ITenantRepository
  ) {}

  async execute(id: number): Promise<void> {
    await this.tenantRepository.delete(id);
  }
}
